import { ConfigDataType } from './config.interface';

export const DEFAULT_CONFIG: ConfigDataType = {
  env: 'development',
  port: 9016,
  selfHost: "http://analytics23.sepl.local",
  logLevel: 'info',
  maxPayloadSize: '10mb',
  responseTimeOut: 600,
  staticFilesFolder: 'files',
  database: {
    type: 'mysql',
    host: '165.22.220.143',
    port: 3306,
    username: 'ramakrishna',
    password: 'Schemax@23',
    dbName: 'ftw_gts',
    poolLimit: 200,
    charset: 'utf8_general_ci',
    // type: 'mysql',
    // host: 'localhost',
    // port: 3306,
    // username: 'root',
    // password: 'root',
    // dbName: 'gts-u23',
    // poolLimit: 100,
    // charset: 'utf8_general_ci'
  },
  gtsDatabase:  {
    type: 'mssql',
    host: '172.25.23.4',
    port: 1433,
    username: 'gts.schemax23',
    password: 'asdf!1234',
    dbName: 'SEPL_Scan',
    poolLimit: 20,
    charset: 'utf8_general_ci'
  },
  rateLimiting: {
    ttl: 60,
    limit: 10,
    maxLoginAttempts: 3
  },
  appSepcific: {
    considerMarginDate: false
  }
};
